import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#2B8FE8" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <p>
              The changes we made improved user experience up to a great level
              and it also brought a drastic improvement in website traffic per
              day and user-conversion rate.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <StaticImage
              src="../../../images/case-studies/oz-leasing/result_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1399}
              height={770}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
